import { createSlice } from "@reduxjs/toolkit";

export const banListSlice = createSlice({
  name: "banList",
  initialState: {
    getBanListResult: false,
    getBanListLoading: false,
    getBanListError: false,
    addBanListResult: false,
    addBanListLoading: false,
    deleteBanListResult: false,
  },
  reducers: {
    banListReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_BANLIST":
          return {
            ...state,
            getBanListResult: payload.data,
            getBanListLoading: payload.loading,
            getBanListError: payload.error,
          };
        case "ADD_BANLIST":
          return {
            ...state,
            addBanListResult: payload.data,
            addBanListLoading: payload.loading,
          };
        case "DELETE_BANLIST":
          return {
            ...state,
            deleteBanListResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { banListReducers } = banListSlice.actions;

export default banListSlice.reducer;
